/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Grid, Typography } from "@material-ui/core";
import * as ROUTES from "./../constants/routes";
import { Link } from "react-router-dom";

//custom libraries
import { useAddCustomerForm } from "../hooks/use-add-customer-form";
import { BackButton, Button, Paper } from "../components";
import addressHelper from "../helpers/addressHelper";
import TextField from "@material-ui/core/TextField";
import { FormInputLabel } from "./../components/common/FormInputLabel";

export default function AddCustomerForm() {
  const {
    handleChange,
    clickSubmit,
    customer,
    canCreate,
    validatePassword,
    t,
    selectedStore,
  } = useAddCustomerForm();

  return (
    <Grid container direction="column" alignItems="stretch" spacing={3}>
      <Grid item>
        <BackButton
          label={t("Common.BackToLanding")}
          component={Link}
          to={ROUTES.DASHBOARD}
        />
      </Grid>
      <Grid item>
        <Typography variant="h1">
          {t("CreateCustomer.AddNewCustomer")}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container direction="row" alignItems="stretch" spacing={4}>
          <Grid item xs={12} md={4} lg={3} xl={2}>
            <Grid container direction="column" justify="flex-start" spacing={2}>
              <Grid item>
                <Typography variant="h3">
                  {t("CreateCustomer.BasicDetails")}
                </Typography>
              </Grid>
              {selectedStore.type === "BMH" && (
                <Grid item>
                   <FormInputLabel text={t("CreateCustomer.Organization")} required />
                  <TextField
                    fullWidth
                    required
                    size="small"
                    variant="outlined"
                    name="parentOrganizationName"
                    onChange={(e: any) => handleChange(e)}
                    inputProps={{
                      maxLength: 254,
                    }}
                  />
                </Grid>
              )}
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.LoginID")} required />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="logonId"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 128,
                  }}
                />
              </Grid>
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.Password")} required />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="password"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 50,
                    type: "password",
                  }}
                />
              </Grid>
              <Grid item>
                <FormInputLabel
                  text={t("CreateCustomer.PasswordVerify")}
                  required
                />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  type="password"
                  name="passwordVerify"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 50,
                    type: "password",
                  }}
                  error={
                    !validatePassword(
                      customer.password,
                      customer.passwordVerify
                    )
                  }
                  helperText={
                    !validatePassword(
                      customer.password,
                      customer.passwordVerify
                    )
                      ? t("CreateCustomer.PasswordValidateMsg")
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3} xl={2}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography variant="h3">
                  {t("CreateCustomer.CustomerDetails")}
                </Typography>
              </Grid>
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.FirstName")} />
                <TextField
                  fullWidth
                  name="firstName"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 40,
                  }}
                />
              </Grid>
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.LastName")} required />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="lastName"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 40,
                  }}
                />
              </Grid>
              <Grid item>
                <FormInputLabel
                  text={t("CreateCustomer.EmailAddress")}
                  required
                />
                <TextField
                  fullWidth
                  required
                  name="email1"
                  onChange={(e: any) => handleChange(e)}
                  variant="outlined"
                  size="small"
                  inputProps={{
                    maxLength: 50,
                    type: "email",
                  }}
                  error={!addressHelper.validateEmail(customer.address.email1)}
                  helperText={
                    !addressHelper.validateEmail(customer.address.email1)
                      ? t("CreateCustomer.EmailValidateMsg")
                      : ""
                  }
                />
              </Grid>
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.PhoneNumber")} />
                <TextField
                  fullWidth
                  name="phone1"
                  variant="outlined"
                  size="small"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 32,
                    type: "tel",
                  }}
                  error={
                    !addressHelper.validatePhoneNumber(customer.address.phone1)
                  }
                  helperText={
                    !addressHelper.validatePhoneNumber(customer.address.phone1)
                      ? t("CreateCustomer.PhoneNumberValidateMsg")
                      : ""
                  }
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3} xl={2}>
            <Grid container direction="column" spacing={2}>
              <Grid item>
                <Typography variant="h3">
                  {t("CreateCustomer.AddressDetails")}
                </Typography>
              </Grid>
              <Grid item>
                <FormInputLabel
                  text={t("CreateCustomer.StreetAddress")}
                  required
                />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="address1"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 99,
                  }}
                />
              </Grid>
              <Grid item>
                <FormInputLabel text={t("CreateCustomer.ZipCode")} required />
                <TextField
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="zipCode"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 30,
                  }}
                />
              </Grid>
              <Grid item>
              <FormInputLabel text={t("CreateCustomer.State")} required />
                <TextField
                 
                  fullWidth
                  required
                  variant="outlined"
                  size="small"
                  name="state"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 40,
                  }}
                />
              </Grid>
              <Grid item>
              <FormInputLabel text={t("CreateCustomer.Country")} required />
                <TextField
                
                  fullWidth
                  required
                  InputLabelProps={{ shrink: true }}
                  variant="outlined"
                  size="small"
                  name="country"
                  onChange={(e: any) => handleChange(e)}
                  inputProps={{
                    maxLength: 40,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4} lg={3} xl={2}>
        <Button
          color="primary"
          fullWidth
          disabled={!canCreate()}
          onClick={(e: any) => clickSubmit(e)}>
          {t("CreateCustomer.CreateAccount")}
        </Button>
      </Grid>
    </Grid>
  );
}
